import React from 'react';

import Text from '../Text';

const InlineText = props => <Text {...props} />;

InlineText.defaultProps = { as: 'span' };

export default InlineText;
